import VaporPage from "@vapor/react-custom/VaporPage";
import { WelcomeMSG } from "./WelcomeMSG";

export const Dashboard = () => (
  <VaporPage title="Dashboard">
    <VaporPage.Section withPadding>
      <WelcomeMSG />
    </VaporPage.Section>
  </VaporPage>
);
